module.exports = __webpack_public_path__ + "static/ig_card_success-c87b899981285da982bfc6a99c534f71.svg";